import { jsx as _jsx } from "react/jsx-runtime";
import { camelCase_to_Sentence, toTitleCase } from '@iotv/core-services';
import { DeviceProvisioningState } from '@iotv/datamodel-core';
import React from 'react';
import CommonTableGraph from '../../../../charts/CommonTableGraph';
const getReason = (record) => {
    if (record.provisioningState === DeviceProvisioningState.ALLOCATED)
        return `${record.inventoryCustomer?.name} to ${record.allocationCustomer?.name}`;
};
const HProvisioningTab = ({ device }) => {
    const provisioning = device?.provisioning ?? [];
    const convertToCommon = (data) => {
        const mapped = data.map((specific) => {
            return {
                Provision: specific.provisioningState ? toTitleCase(camelCase_to_Sentence(DeviceProvisioningState[specific.provisioningState])) : undefined,
                Reason: getReason(specific),
                User: specific.manager,
                _Time: specific.provisionDate,
            };
        });
        if (mapped.length === 0)
            mapped.push({
                Provision: 'No provisioning found',
                _Time: undefined,
            });
        return { data: mapped };
    };
    return _jsx(CommonTableGraph, { ...convertToCommon(provisioning) });
};
export default HProvisioningTab;
